import React from 'react';
import { SquareCard } from '../../../interfaces/stripe_payment_method';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import PillLabel from '../../../components/PillLabel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { CreditCardIcon } from '@heroicons/react/20/solid';

type Props = {
  card: SquareCard;
  onClick: () => void;
};

const SquareCardView: React.FC<Props> = ({ card, onClick }) => {
  const isEditMode = useSelector<RootState, boolean>(
    state => state.payment.edit_mode,
  );
  return (
    <div className="py-2 px-4 bg-surface rounded" onClick={onClick}>
      <div className="flex flex-col p-4 bg-primary/10 h-full rounded-lg shadow-lg items-center justify-center align-middle">
        <div className="flex flex-row w-full items-center justify-between">
          <div className="text-on-surface flex flex-row items-center text-sm text-left justify-left content-center">
            <CreditCardIcon className="w-6 h-6 text-primary" />
            {/* <FontAwesomeIcon icon={faCreditCard} color="green" className="" /> */}
            <div className="pl-2 items-center text-on-surface">
              {card.card_brand.toUpperCase()}
            </div>
            <div className="pl-1 text-on-surface">{card.last_4}</div>
          </div>
          <div className="text-on-surface flex flex-row items-center text-sm text-right justify-right content-center">
            <PillLabel
              color={isEditMode ? 'bg-tertiary' : 'bg-primary'}
              label={isEditMode ? 'Delete' : 'Select'}
              text_color={isEditMode ? 'text-on-tertiary' : 'text-on-primary'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SquareCardView;
